/* unplugin-vue-components disabled */import { render } from "./mobile.vue?vue&type=template&id=c9ed665c&scoped=true&ts=true"
import script from "./mobile.vue?vue&type=script&lang=ts"
export * from "./mobile.vue?vue&type=script&lang=ts"

import "./mobile.vue?vue&type=style&index=0&id=c9ed665c&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yunxiaobao-test/prod-yunxiaobao-com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9ed665c"]])

export default __exports__